export default "__VITE_ASSET__DxcfcVLB__"